import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-layout-unauthenticated',
  templateUrl: './layout-unauthenticated.component.html',
  styleUrls: ['./layout-unauthenticated.component.scss'],
})
export class AppLayoutUnauthenticatedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
